window.inflComp = window.inflComp || {};

require('./shared/polyfill');
import 'react-toastify/scss/main.scss';

if ( !window.console || !window.console.log ) {
  window.console = {
    log: function(s) {
      // no-op for legacy browsers and IE
    }
  }
}

inflComp.React          = require('react');
inflComp.ReactDOM       = require('react-dom');
inflComp.HelpTooltip    = require('patternity/lib/help_tooltip');
inflComp.Loading        = require('patternity/lib/loading');
inflComp.ModalDialog    = require('patternity/lib/modal_dialog');
inflComp.TwitterProfile = require('components/twitter_profile');
inflComp.Loading        = require('patternity/lib/loading');
inflComp.Tooltip        = require('patternity/lib/tooltip');
inflComp.Reactions     = require('@influitive/reaction-fe');
inflComp.HubSwitcher    = require('components/hub_switcher');
inflComp.badgePopover   = require('components/badge_popover');
inflComp.Onboarding        = require('advocate/onboarding');
inflComp.InflunetPromotion = require('advocate/components/influnet_promotion');
inflComp.Stages = {
  Quiz: {
    Show : require('advocate/stages/quiz/main')
  }
};
inflComp.Partials = {
  Advocate: {
    Rewards: {
      ViewRewardDetails : require('advocate/rewards/_view_reward_details')
    },
    Challenges: {
      Browser: require('advocate/challenges/browser')
    }
  }
};


inflComp.convertFileToImage = require('advocate/onboarding/components/profile_image_helper').convertFileToImage;
inflComp.resetImageStyle = require('advocate/onboarding/components/profile_image_helper').resetImageStyle;
inflComp.adjustImageStyling = require('advocate/onboarding/components/profile_image_helper').adjustImageStyling;
inflComp.profileCard = require('@influitive/profile-card/lib').default;
inflComp.renderReactComponent = require('shared/render-react-component');
inflComp.componentRegistry = require('shared/component-registry');
inflComp.newModalDialog = require('shared/new-modal-dialog');

module.exports = inflComp;



// WEBPACK FOOTER //
// ./src/exports-advocate.js